<template>
    <div class="flex flex-col overflow-hidden">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="overflow-hidden">
                    <table class="min-w-full">
                        <thead :class="headClass">
                            <slot name="headers" v-bind="scope">
                                <tr>
                                    <th scope="col" :class="effectiveHeaderCellClass" v-for="(header, index) in headers" :key="index" v-text="header"></th>
                                </tr>
                            </slot>
                        </thead>
                        <tbody :class="bodyClass">
                            <slot v-bind="scope"></slot>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        headers: Array,
        bodyClass: String,
        headClass: {
            type: String,
            default: 'bg-gray-50',
        },
        headerCellClass: String,
        cellClass: String,
        compact: Boolean,
    },
    data(){
      return {
        smallHeaderCellClass: 'px-2 py-3 text-left text-xs font-semibold text-gray-400',
        smallCellClass: 'px-2 py-3 whitespace-nowrap text-xs text-gray-500 text-left'
      }
    },
    computed: {
        effectiveCellClass () {
            if (this.cellClass) return this.cellClass
            return this.compact
                ? 'px-2 py-3 whitespace-nowrap text-xs text-gray-500'
                : 'px-6 py-4 whitespace-nowrap text-sm text-gray-500'
        },
        effectiveHeaderCellClass () {
            if (this.headerCellClass) return this.headerCellClass
            return this.compact
                ? 'px-2 py-1 text-left text-xs font-semibold text-gray-400'
                : 'px-6 py-1 text-left text-xs font-semibold text-gray-400'
        },
        scope () {
            return {
                headers: this.headers,
                headClass: this.headClass,
                bodyClass: this.bodyClass,
                headerCellClass: this.effectiveHeaderCellClass,
                cellClass: this.effectiveCellClass,
            }
        },
    },
}
</script>
